import * as Sentry from '@sentry/react';
import { scrubBreadcrumb } from './sentryBreadcrumbs.ts';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment:
      (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ??
      import.meta.env.MODE ??
      'production',
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.breadcrumbsIntegration({ console: false }),
      // When tracesSampleRate is raised above 0, swap to the router-aware
      // integration for proper transaction names:
      // Sentry.reactRouterV7BrowserTracingIntegration({
      //   useEffect, useLocation, useNavigationType,
      //   createRoutesFromChildren, matchRoutes,
      // }),
    ],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'Non-Error promise rejection captured',
      'Network request failed',
      'AbortError',
      'CanceledError',
    ],
    // Fetch, XHR and navigation breadcrumbs keep no query string: one can
    // carry an export credential (`?t=`). See sentryBreadcrumbs.ts.
    beforeBreadcrumb: scrubBreadcrumb,
    beforeSend(event) {
      if (event.request?.url) {
        try {
          const url = new URL(event.request.url);
          url.search = '';
          event.request.url = url.toString();
        } catch {
          // ignore
        }
      }
      return event;
    },
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
export { Sentry };
